import { categories } from "@/mocks/hotNews";

export function getCategory(id: string) {
  return categories.find((c) => c.id === id) ?? categories[0];
}

export function formatViews(v: number) {
  if (v >= 10000) {
    return `${(v / 10000).toFixed(1)}万`;
  }
  return `${v}`;
}

export const hotRankBadge = [
  "bg-accent-500 text-background-50",
  "bg-background-300 text-foreground-800",
  "bg-primary-200 text-primary-900",
];